export const measurementTypeFacts = {
  length: [
    "The 'furlong' was originally the length of a furrow in a medieval English open-field system—the distance a team of oxen could plow without resting.",
    "The 'hand' measurement, still used for measuring horses today, was standardized by Henry VIII to exactly 4 inches.",
    "The Roman foot (pes) varied across the empire but was approximately 11.65 modern inches.",
    "The 'cubit' was based on the length from the elbow to the tip of the middle finger.",
    "The 'league' originally represented the distance a person could walk in an hour.",
    "The yard was standardized in 1101 by King Henry I of England as the distance from his nose to the thumb of his outstretched arm."
  ],
  weight: [
    "The 'stone' weight originated from the practice of using certified stones as weight references in trade.",
    "The 'grain' weight unit originated from the weight of a single grain of wheat or barley.",
    "The 'talent' was one of the largest ancient weight units, used throughout the Mediterranean.",
    "The 'shekel' was an ancient unit of weight and currency in Mesopotamia.",
    "The 'carat' originally came from the weight of carob seeds, which were remarkably consistent in mass.",
    "The 'pound' derives from the Roman 'libra', which is why the abbreviation 'lb' is used."
  ],
  volume: [
    "The 'gill' measure dates back to medieval England and was commonly used for measuring wine and spirits.",
    "The 'hogshead' was standardized in England in 1423 as 63 wine gallons.",
    "The 'bushel' was originally a volume measure for dry goods like grain, standardized in the 13th century.",
    "The 'firkin' was traditionally used for measuring ale and butter.",
    "The 'pottle' was half a gallon and commonly used in medieval taverns.",
    "The 'pint' comes from the Old French 'pinte', possibly from vulgar Latin 'pincta'."
  ],
  temperature: [
    "The Réaumur scale was widely used in Europe and Russia in the 18th and 19th centuries.",
    "The Rankine scale, created in 1859, is the absolute scale counterpart to the Fahrenheit scale.",
    "The Celsius scale was originally defined with 0° as the boiling point and 100° as the freezing point of water.",
    "Fahrenheit based his scale on three points: 0°F (freezing point of brine), 32°F (freezing point of water), and 96°F (human body temperature).",
    "The Kelvin scale is named after William Thomson, 1st Baron Kelvin, who wrote about the need for an 'absolute' temperature scale."
  ],
  time: [
    "The 'moment' was a medieval unit of time equal to 1/40th of an hour, or 90 seconds.",
    "The 'fortnight' (14 nights) comes from the Old English 'fēowertyne niht'.",
    "A 'jiffy' was historically defined as the time between two ticks of a clock's pendulum.",
    "The word 'month' comes from the Moon's orbit around Earth.",
    "The ancient Egyptians were the first to divide days into 24 hours."
  ],
  area: [
    "The 'hide' was an Old English unit of land sufficient to support a family.",
    "The 'barn' is a very small unit of area used in nuclear physics.",
    "The 'morgen' was originally the amount of land that could be plowed in a morning.",
    "The 'acre' was defined as the amount of land a yoke of oxen could plow in one day.",
    "The 'rood' was a quarter of an acre and was a common medieval land measurement."
  ],
  speed: [
    "The 'knot' originated from counting knots in a rope while it played out behind a moving ship.",
    "The 'furlong per fortnight' is often used humorously as an example of an impractical unit.",
    "Ancient Roman road speeds were often measured in leagues per day.",
    "The term 'miles per hour' became standardized with the advent of railways in the 19th century."
  ]
};